var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmoke(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 28 28",
    style: {
      enableBackground: "new 0 0 28 28"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#4F84E8;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.5,14.6L25.5,14.6C25.5,14.6,25.5,14.6,25.5,14.6L25.5,14.6C25.5,14.6,25.5,14.6,25.5,14.6 C25.5,14.6,25.5,14.6,25.5,14.6L25.5,14.6C25.5,14.6,25.5,14.6,25.5,14.6C25.5,14.6,25.5,14.6,25.5,14.6 C25.5,14.6,25.5,14.6,25.5,14.6C25.5,14.6,25.5,14.6,25.5,14.6C25.5,14.6,25.5,14.6,25.5,14.6C25.5,14.6,25.5,14.6,25.5,14.6 C25.5,14.6,25.5,14.6,25.5,14.6C25.5,14.6,25.5,14.6,25.5,14.6C25.5,14.6,25.5,14.6,25.5,14.6C25.5,14.6,25.5,14.6,25.5,14.6 C25.5,14.6,25.5,14.6,25.5,14.6C25.5,14.6,25.5,14.6,25.5,14.6C25.5,14.6,25.5,14.6,25.5,14.6C25.5,14.6,25.5,14.6,25.5,14.6 C25.5,14.6,25.5,14.6,25.5,14.6C25.5,14.6,25.5,14.6,25.5,14.6C25.5,14.6,25.5,14.6,25.5,14.6C25.5,14.6,25.5,14.6,25.5,14.6 c-0.1,0-0.1,0-0.1,0c-0.1,0-0.3,0-0.6,0c-0.1,0-0.2,0-0.3,0c0.1-0.1,0.2-0.3,0.2-0.4c0-1.6-1.3-2.9-2.9-2.9h-1 c-0.7,0-1.3-0.6-1.3-1.3V9c0-0.4-0.4-0.8-0.8-0.8c-0.4,0-0.8,0.4-0.8,0.8v1c0,1.6,1.3,2.9,2.9,2.9h1c0.7,0,1.3,0.6,1.3,1.3 c0,0.2,0.1,0.3,0.2,0.4c-0.5,0-1.2,0-2,0l0,0c-0.4,0-0.7,0.3-0.7,0.7c0,0.4,0.3,0.7,0.7,0.7H23v4H9.7v-4h8.6c0.4,0,0.7-0.3,0.7-0.7 c0-0.4-0.3-0.7-0.7-0.7l-15.8,0V15h0l0-0.4h0c-1.1,0-2.1,0.9-2.1,2.1v0v2.8v0c0,1.1,0.9,2.1,2.1,2.1h0h23.1h0 c1.1,0,2.1-0.9,2.1-2.1v-2.8C27.6,15.6,26.7,14.6,25.5,14.6z M8.2,20.1H2.5c-0.3,0-0.6-0.3-0.6-0.6v-2.8c0-0.3,0.3-0.6,0.6-0.6h5.8 V20.1z M26.1,19.5c0,0.3-0.3,0.6-0.6,0.6h-1v-4h1c0.3,0,0.6,0.3,0.6,0.6V19.5z M25.5,15L25.5,15L25.5,15L25.5,15L25.5,15 C25.5,15,25.5,15,25.5,15L25.5,15L25.5,15z M25.5,15L25.5,15L25.5,15L25.5,15L25.5,15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24.5,11.3h1c0.4,0,0.8-0.4,0.8-0.8s-0.4-0.8-0.8-0.8h-1c-0.7,0-1.3-0.6-1.3-1.3v-1c0-0.4-0.4-0.8-0.8-0.8 c-0.4,0-0.8,0.4-0.8,0.8v1C21.5,10,22.8,11.3,24.5,11.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmoke);
export default __webpack_public_path__ + "static/media/smoke.5663a0216e1eb1974b21944fedb88867.svg";
export { ForwardRef as ReactComponent };